import src from "IMAGE";
export default { src, width: 579, height: 176, blurWidth: 0, blurHeight: 0};
